import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7sddd34i: FaireBrandEntity = {
  token: "b_7sddd34i",
  type: "brand",
  name: "Tai Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/d936c68c0147decb5840f9e30974c18ebf801022e6998e5e7a5100263baf8354.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d174792e578edfdfc65f10d84de32c1dc80bae1524d9aee6d63452ba3739d78.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d936c68c0147decb5840f9e30974c18ebf801022e6998e5e7a5100263baf8354.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d174792e578edfdfc65f10d84de32c1dc80bae1524d9aee6d63452ba3739d78.jpeg",
  location: "Pasadena, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Born and raised in Bangkok, Thailand, Tai's artistic upbringing and interest in jewelry making blossomed into a full-time business in 2002.\n\nTai moved to California to study at California State University, Fresno. After graduating, Tai's entrepreneurial spirit led her to Los Angeles. It was there that Tai noticed that there was a lack of high-quality fashion jewelry with fine jewelry finishing and details. So, Tai created a line of bracelets and began to sell them at the Santa Monica flea market. There, she was discovered by the leading fashion and trendsetting boutiques. One simple design inspired an extensive collection of jewelry, including earrings, necklaces, bracelets and rings. \n\nTai's is proud to employ and support some of the finest artisans, women, and artists in Thailand. Not only does she strive to keep the art of handcrafted jewelry alive, but she supports the community in which the artisans live. She is actively involved with multiple charities both in her native Thailand and the United States.\n\nTAI Jewelry is currently sold worldwide in specialty boutiques, catalogs, and major retailers. Tai opened her wholesale showroom and first retail store in Manhattan's trendy Nolita neighborhood in the late summer of 2016. She continues to find inspiration all over the world but is especially captivated by the flea markets of Paris.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:00.207Z",
    importedBy: "entity-db-cli",
  },
};
